/* @flow */
import apiRequest from 'lib/apiRequest';
import { Component } from 'react';
import ToastActions from 'actions/ToastActions';

// for mocking in tests
export const libs = {
  apiRequest,
};

export default class QuickLinkView extends Component {
  static onEnter(nextState, replaceWith, callback) {
    if (!nextState.params.token) {
      replaceWith('/not_found');
      callback();
    } else {
      libs.apiRequest('/quicklink', 'POST', { token: nextState.params.token }).then(
        (res) => {
          ToastActions.showSuccessToast(res.message);
          replaceWith('/landing');
          callback();
        },
        (res) => {
          const message = res.message || 'Oops. That link didn’t work.';
          ToastActions.showErrorToast(message);
          replaceWith('/landing');
          callback();
        }
      );
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/QuickLinkView.jsx